import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getAllUserAssignments = () =>
  apiClient.get(`${REST_API_BASE_URL}/assignments`);

//export const getAllAdminMemberships = () => apiClient.get(`${REST_API_BASE_URL}/mymemberships`);

export const removeUserFromGroup = (group, userid) =>
  apiClient.delete(`${REST_API_BASE_URL}/group/${group}/user/${userid}`);

export const addUserToMembership = (accid, userid) =>
  apiClient.post(`${REST_API_BASE_URL}/membership/${accid}/user/${userid}`);

export const getAdminMembershipsAndSubscriptions = () =>
  apiClient.get(`${REST_API_BASE_URL}/mymemberships-with-subscriptions`);

export interface AdminStats {
  totalUsers: number;
  totalSubscriptions: number;
  activeTrials: number;
  publishedPlans: number;
  publishedTemplates: number;
}

export const getAdminStats = () =>
  apiClient.get<AdminStats>(`${REST_API_BASE_URL}/stats`);

export default apiClient;
